import type {RentalCalendarFilterOptions} from '../hooks/useRentalCalendarFilterOptions';

/**
 * Label of one selected filter value. Make and model arrive as grouped options, so groups are
 * flattened first; an unknown value falls back to the raw code rather than rendering an empty chip.
 */
export function findFilterOptionLabel(options: RentalCalendarFilterOptions, value: string) {
  const flatOptions = options.flatMap((option) =>
    'options' in option ? [...option.options] : [option]
  );

  return flatOptions.find((option) => option.value === value)?.label ?? value;
}
